// extracted by mini-css-extract-plugin
export default {"card":"card_card__9dXHF","iconContainer":"card_iconContainer__12Lqi","title":"card_title__lxRS2","description":"card_description__-fgQf"};